import { useState } from 'react';

import { Button } from './sub/Button';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const NavLink: React.FC<{ href: string; children: React.ReactNode; mdHidden?: boolean }> = ({
    href,
    children,
    mdHidden
  }) => {
    return (
      <a
        href={href}
        className={`block md:${mdHidden ? 'hidden' : 'inline'} hover:text-blue-500 py-2`}
        onClick={() => setIsOpen(false)}
      >
        {children}
      </a>
    );
  };
  return (
    <header
      className={`sticky top-0 z-50 shadow-lg  shadow-[#0000000D] ${
        !isOpen ? 'backdrop-blur-md bg-[#F0FDF8BF]' : 'bg-[#F0FDF8]'
      }`} // Remove blur when menu is open due to bug in chorme https://www.reddit.com/r/Frontend/comments/xm2ft0/cant_get_backdropfilter_blur16px_to_work_in/
    >
      <div className="mx-auto flex justify-between items-center py-4 px-6">
        {/* Brand Logo */}
        <a href="/#home">
          <h1 className="bri text-3xl md:text-5xl font-bold">Zittle</h1>
        </a>

        {/* Hamburger Menu (Visible on Small Screens) */}
        <button
          className="md:hidden text-2xl text-[#202322] focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? '✖' : '☰'}
        </button>

        {/* Navigation Links */}
        <nav
          className={`int text-base font-semibold text-[#202322] space-x-6 md:space-x-14 md:flex ${
            isOpen ? 'block' : 'hidden'
          } absolute md:static top-16 left-0 w-full md:w-auto bg-[#F0FDF8BF] md:bg-transparent ${
            isOpen ? 'backdrop-blur-md' : '' // Apply blur only when menu is open
          } md:backdrop-blur-none p-4 md:p-0 shadow-md md:shadow-none`}
        >
          {isOpen && (
            <NavLink href="/#home" mdHidden>
              Home
            </NavLink>
          )}
          <NavLink href="/#services">Services</NavLink>
          <NavLink href="/#benefits">Benefits</NavLink>
          <NavLink href="/#events">Events</NavLink>
          <NavLink href="/#about">About Us</NavLink>
          <NavLink href="/#pricing">Pricing</NavLink>
          <NavLink href="/#faqs">FAQ</NavLink>
          <NavLink href="/#contact-us" mdHidden>
            Contact Us
          </NavLink>
          {/* <a href="/login" className="block md:hidden hover:text-blue-500 py-2">
            Get Started
          </a> */}
        </nav>

        {/* Button (Hidden on Small Screens) */}
        <div className="hidden md:flex space-x-2">
          <a
            href="/login"
            className="int border-2 border-gray-500 text-[#202322] font-semibold px-6 py-3 rounded-xl hover:bg-green-200"
          >
            Get Started
          </a>
          <Button />
        </div>
      </div>
    </header>
  );
};

export default Navbar;
